import { useEffect } from "react";

// Keeps the screen from dimming or locking while active is true (a card is
// running), so a timer on a tablet or beamer laptop stays visible. Browsers
// drop the lock when the tab is hidden, so it's requested again whenever
// the page becomes visible. Where the Wake Lock API is missing or refused
// (older Safari, low battery mode) this quietly does nothing.
export default function useWakeLock(active) {
  useEffect(() => {
    if (!active || !("wakeLock" in navigator)) {
      return undefined;
    }
    let lock = null;
    let cancelled = false;

    const request = async () => {
      if (document.visibilityState !== "visible" || lock) {
        return;
      }
      try {
        const acquired = await navigator.wakeLock.request("screen");
        if (cancelled) {
          acquired.release();
          return;
        }
        lock = acquired;
        lock.addEventListener("release", () => {
          lock = null;
        });
      } catch (error) {
        // Refused (e.g. battery saver) - nothing to do.
      }
    };

    request();
    document.addEventListener("visibilitychange", request);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", request);
      lock?.release();
    };
  }, [active]);
}
